<template>
  <div class="bike-reset">
    <BfButton
      v-if="hasPositioningMotors"
      :type="ButtonType.Outlined"
      @click="homing"
    >
      {{ t('common.homing') }}
    </BfButton>
    <BfButton
      :type="ButtonType.Outlined"
      @click="resetMotors"
    >
      {{ t('common.resetMotors') }}
    </BfButton>
    <BfButton
      :type="ButtonType.Outlined"
      @click="reboot"
    >
      {{ t('common.reboot') }}
    </BfButton>
    <BfButton
      :type="ButtonType.Outlined"
      @click="shutdown"
    >
      {{ t('common.shutdown') }}
    </BfButton>
  </div>
</template>

<script setup lang="ts">
import { BfButton, ButtonType } from '@finetic/bikefitting-ui'
import { useMessage } from 'naive-ui'
import { usePreferenceStore } from '@/store/preferenceStore'
import { useMqttStore } from '@/store/mqttStore'
import { usePositionStore } from '@/store/positionStore'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const preferenceStore = usePreferenceStore()
const mqttStore = useMqttStore()
const positionStore = usePositionStore()
const message = useMessage()

const { t } = useI18n()

const { destroyConnection } = mqttStore
const { resetPosition, startHoming, doResetMotors, doReboot, doShutdown } =
  positionStore

const { hasPositioningMotors } = storeToRefs(preferenceStore)
const { client } = storeToRefs(mqttStore)

const homing = () => {
  startHoming()
  message.loading(t('common.fitbike.homing'))
}

const resetMotors = () => {
  doResetMotors()
  message.loading(t('common.fitbike.resetMotors'))
}

const reboot = () => {
  doReboot()
  resetApp()
  message.loading(t('common.fitbike.reboot'))
}

const shutdown = () => {
  doShutdown()
  resetApp()
  message.loading(t('common.fitbike.shutdown'))
}

const resetApp = () => {
  destroyConnection(client.value)
  resetPosition()
  router.push({ name: 'start' })
}
</script>

<style lang="scss">
.bike-reset {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
